<div class="container">
  <mat-card appearance="outlined">
    <mat-card-title>State Master</mat-card-title>
    <button
      mat-fab
      (click)="exportExcel()"
      color="accent"
      style="
        position: absolute;
        right: 20px;
        top: 8px;
        width: 35px;
        height: 35px;
      "
      *ngIf="states != null && states.length > 0"
      matTooltip="Download Records"
    >
      <span class="mat-mdc-button-wrapper">
        <i class="material-icons" style="font-size: 30px">download</i>
      </span>
    </button>
    <mat-card-subtitle></mat-card-subtitle>
    <mat-card-content>
      <div class="table-responsive">
        <table
          mat-table
          [dataSource]="dataSource"
          class="mat-elevation-z8"
          matSort
          (matSortChange)="announceSortChange($event)"
          *ngIf="states != null"
           aria-label="Table listing states"
        >
          <ng-container matColumnDef="S.No">
            <th mat-header-cell *matHeaderCellDef>S No.</th>
            <td mat-cell *matCellDef="let element; let i = dataIndex">
              {{ dataSource.filteredData.indexOf(element) + 1 }}
            </td>
          </ng-container>
          <!-- stateName Column -->
          <ng-container matColumnDef="stateName">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              sortActionDescription="Sort by stateName"
            >
              State Name
            </th>
            <td mat-cell *matCellDef="let element">{{ element.stateName }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <mat-paginator
          [length]="resultLength"
          [pageSize]="25"
          [pageSizeOptions]="[25, 50, 100]"
          aria-label="Select page"
        ></mat-paginator>
        <div *ngIf="isLoaderResult" class="custSpinner"></div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
